import React, { useState } from 'react';
import Modal from 'react-modal';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import Label from '@/components/form/Label/Label';
import classNames from 'classnames';
import { FaCog } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import { cleanSrcForJPG } from '@/helpers/imagesHelpers';
import DetailedSpaceInfo from '@/components/reusable/DetailedSpaceInfo';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import './NewSpaceCardBlueVersion.scss';

Modal.setAppElement('#root');

const truncateDescription = (description, limit) => {
  if (description?.length > limit) {
    return description.substring(0, limit) + '...';
  }
  return description;
};

const NewSpaceCardBlueVersion = props => {
  const {
    spaceInfo,
    isMobileStyle,
    handleDetailButton,
    isInlineStyle,
    isWhiteVersion,
    isBlueVersion,
    isPurple1Version,
    isGreyVersion,
    isPurple2Version,
    isLightGradientBlueVersion,
    priceAndCapacityDetails,
    isCarousel,
    isActive,
    categoriesPills,
  } = props;

  const lenguage = useSelector(state => state.lenguage?.lang);
  const user = useSelector(state => state.user);

  const translations = {
    'Sala de Juntas': 'Meeting Room',
    Terrazas: 'Terrace',
    Coworking: 'Coworking Pass',
  };

  const translatedTitle =
    translations[spaceInfo?.subtype_title] || spaceInfo?.subtype_title;
  let fontColor = '';

  if (isBlueVersion || isLightGradientBlueVersion) {
    fontColor = ' fontGray050';
  } else {
    fontColor = ' fontBlack050';
  }

  const containerClass = classNames(
    'spaceCardBlueVersion borderGray050 border-rad8px height-280px ',
    {
      'gap-20 m-flex-column': isInlineStyle,
      'flex-column format100': !isInlineStyle,
      margtb20: isMobileStyle,
      whiteVersion: isWhiteVersion,
      blueVersion: isBlueVersion,
      lightGradientBlueVersion: isLightGradientBlueVersion,
      purple1Version: isPurple1Version,
      greyVersion: isGreyVersion,
      purple2Version: isPurple2Version,
    },
  );

  const textContainerClass = classNames('padlr6 justify-between gap-10', {
    'justify-around': isInlineStyle,
  });

  const mobileImageItemStyle = {
    width: '100%',
    height: '200px',
    objectFit: 'cover',
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
  };

  const imagesArray = (() => {
    try {
      const parsed =
        spaceInfo?.url_img && spaceInfo?.url_img !== null
          ? JSON.parse(spaceInfo?.url_img)
          : JSON.parse(spaceInfo?.main_image);
      return Array.isArray(parsed) && parsed.length > 0
        ? parsed
        : [spaceInfo?.main_image].filter(Boolean);
    } catch {
      return [spaceInfo?.main_image].filter(Boolean);
    }
  })();

  const typeSpanStyle = { zIndex: 2 };
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const customModalStyles = {
    overlay: {
      position: 'fixed',
      zIndex: 1000,
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      transform: 'translate(-50%, -50%)',
      padding: '20px',
    },
  };

  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  return (
    <FlexContainer
      className={containerClass}
      onClick={handleDetailButton}
      style={{ position: 'relative' }}
    >
      {/*   {user && (
        <div
          className="icon-container"
          onClick={e => {
            e.stopPropagation();
            openModal();
          }}
        >
          <FaCog size={24} color="#808080" />
        </div>
      )} */}

      {categoriesPills && (
        <>
          <span
            style={typeSpanStyle}
            className="leftPill bgWhite fontGray500 text-12 padtb4 padlr4 pos-abs marglr10"
          >
            <strong>Elegant</strong>
          </span>
          <span
            style={typeSpanStyle}
            className="rightPill bgPink1 fontWhite text-12 padtb4 padlr4 pos-abs margr16"
          >
            <strong> DEAL</strong>
          </span>
        </>
      )}
      {imagesArray?.length > 1 && isCarousel && (
        <FlexContainer className="width100 d-hide">
          <Swiper
            loop={true}
            autoplay={{
              delay: 10500,
              disableOnInteraction: true,
            }}
            pagination={{
              clickable: true,
            }}
            modules={[Autoplay, Pagination]}
            spaceBetween={0}
            slidesPerView={1}
          >
            {imagesArray?.map((image, index) => (
              <SwiperSlide key={index}>
                <img
                  loading="lazy"
                  src={cleanSrcForJPG(image)}
                  alt={spaceInfo?.space_name}
                  style={{
                    ...mobileImageItemStyle,
                  }}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </FlexContainer>
      )}
      {(!isCarousel || imagesArray?.length === 1) && (
        <FlexContainer className="width100">
          <img
            src={cleanSrcForJPG(imagesArray[0])}
            alt={spaceInfo?.space_name}
            loading="lazy"
            style={{
              ...mobileImageItemStyle,
            }}
          />
        </FlexContainer>
      )}

      <FlexContainer className={textContainerClass}>
        <FlexContainer className="flex-column margt20 margb10 format140">
          <Label className={'text-16 align-self-start ' + fontColor}>
            <strong>
              <div
                style={{ fontWeight: 800 }}
                dangerouslySetInnerHTML={{
                  __html: truncateDescription(
                    spaceInfo?.relationship_title,
                    17,
                  ),
                }}
              />
            </strong>
          </Label>
          <Label
            className={'align-self-start text-12 margt6 gap-4 ' + fontColor}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polygon points="12 2 15 9 22 9 17 14 19 21 12 17 5 21 7 14 2 9 9 9" />
            </svg>
            <span> 100% | Mexico City</span>
          </Label>
        </FlexContainer>
        <FlexContainer className="flex-column margt20 margb10 format80 text-right">
          <Label
            className={
              'text-right text-18 ' +
              (isBlueVersion === true || isLightGradientBlueVersion === true
                ? 'fontWhite'
                : 'fontGray300')
            }
          >
            <strong>
              {spaceInfo?.currency + ' ' + spaceInfo?.calculatedPrice}
            </strong>
          </Label>
          <FlexContainer className="width100 text-right flex-column">
            {lenguage === 'ES' ? (
              <>
                <Label className={'text-right ' + fontColor} type="text-10">
                  {spaceInfo?.subtype_title === 'Coworking'
                    ? 'por día'
                    : 'por hora'}
                </Label>
                <Label className={'text-right ' + fontColor} type="text-10">
                  Incluye impuestos
                </Label>
              </>
            ) : (
              <>
                <Label className={'text-right ' + fontColor} type="text-10">
                  {spaceInfo?.subtype_title === 'Coworking'
                    ? 'per day'
                    : 'per hour'}
                </Label>
                <Label className={'text-right ' + fontColor} type="text-10">
                  Includes fees
                </Label>
              </>
            )}
          </FlexContainer>
        </FlexContainer>
      </FlexContainer>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customModalStyles}
        contentLabel="Detailed Space Info"
      >
        <div onClick={e => e.stopPropagation()}>
          <DetailedSpaceInfo spaceInfo={spaceInfo} closeModal={closeModal} />
        </div>
      </Modal>
    </FlexContainer>
  );
};

export default NewSpaceCardBlueVersion;
